import { userAxios } from '../index'

/**
 * Obtiene todos los planes disponibles para que un miembro agregue uno nuevo.
 * Reutiliza el mismo endpoint de landings.
 */
export const getAllMemberPlans = async () => {
  try {
    const response = await userAxios.get('get-plans/all')
    return response.data
  } catch (error) {
    console.error('Error al obtener los planes para el miembro:', error)
    throw error
  }
}

/**
 * Agrega un nuevo plan al paciente logueado.
 * POST /users/patients/add-user-plan
 * @param {number} membershipsParametersId
 * @param {number} cash
 * @param {number} cc
 */
export const addUserPlan = async ({ membershipsParametersId, cash, cc }) => {
  try {
    const response = await userAxios.post('users/patients/add-user-plan', {
      memberships_parameters_id: membershipsParametersId,
      cash,
      cc,
    })
    return response.data
  } catch (error) {
    console.error('Error al agregar nuevo plan para el miembro:', error)
    throw error
  }
}

